import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class WildcardGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const isTouAccepted = localStorage.getItem('isTouAccepted') === 'true';

    this.router.navigate([isTouAccepted ? '/task' : '/login']);
    return false;
  }
}
